import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var GasPump = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M19.616 6.48l.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 00-1.395 3.058c.149.899.766 1.676 1.565 2.112.897.49 1.685.446 2.384.197L18.976 18a.996.996 0 01-1.39.922.995.995 0 01-.318-.217.996.996 0 01-.291-.705L17 16a2.98 2.98 0 00-.877-2.119A3 3 0 0014 13h-1V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 01.531.533A.994.994 0 0115 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 002.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0020.976 18L21 9a2.997 2.997 0 00-1.384-2.52zM4 5h7l.001 4H4V5zm0 14v-8h7.001l.001 8H4zm14-9a1 1 0 110-2 1 1 0 010 2z",
    key: "k0"
  }));
});
GasPump.displayName = 'GasPump';
export var GasPumpDimensions = {
  height: 24,
  width: 24
};